export const ACTIVE_NUMERATOR = 'activeNumerator';
export const ACTIVE_NUMERATOR_UNIT = 'activeNumeratorUnit';
export const ALTERNATE_NAME = 'alternateName';
export const CUSTOM_NAME = 'customName';
export const DATE_PRESCRIBED = 'datePrescribed';
export const DOSAGE = 'dosage';
export const FREQUENCY = 'frequency';
export const FREQUENCY_UNIT = 'frequencyUnit';
export const IS_SEARCH_RESULT = 'isSearchResult';
export const MEDICATION_TYPES = {
  LIQUID: 'Liquid',
  PILL: 'Pill or Tablet',
  IV: 'IV',
  NEBULIZER: 'Nebulizer',
  OTHER: 'Other',
};
export const MEDICATION_NAME = 'fdaMedication';
export const MEDICATION_NOTES = 'notes';
export const PHARMACY_ID = 'pharmacyId';
export const PRESCRIBING_DOCTOR_ID = 'prescribingDoctorId';
export const PRN = 'prn';
export const TYPE = 'type';



// WEBPACK FOOTER //
// ./src/modules/MedicationPage/constants.js